import { render, staticRenderFns } from "./flower-table.vue?vue&type=template&id=1324748a&scoped=true&lang=pug&"
import script from "./flower-table.vue?vue&type=script&lang=js&"
export * from "./flower-table.vue?vue&type=script&lang=js&"
import style0 from "./flower-table.vue?vue&type=style&index=0&id=1324748a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324748a",
  null
  
)

export default component.exports